module.exports = __webpack_public_path__ + "static/media/illustration-mockups.88090ace.svg";